export default __webpack_public_path__ + "static/media/Group9245.2f17089e.svg";